<template>
  <tabBar :idIndex="3"></tabBar>
  <OpularDisease :flag="false"></OpularDisease>


  <Bottom></Bottom>
</template>
<script setup>
import tabBar from '@/components/tabBar/tabIndex.vue'
import Bottom from '@/components/bottom/footNavigation.vue'
import OpularDisease from '@/views/Page/OpularDisease.vue'



</script>
<style lang="scss" scoped>



</style>
